<template>

<div class="card">
    <div class="front">

      <div class="chip">
        <div class="chip-line"></div>
        <div class="chip-line"></div>
        <div class="chip-line"></div>
        <div class="chip-line"></div>
        <div class="chip-main"></div>
      </div>

      <svg class="wave" viewBox="0 3.71 26.959 38.787" width="21.567" height="31.029" fill="white">
          <path d="M19.709 3.719c.266.043.5.187.656.406 4.125 5.207 6.594 11.781 6.594 18.938 0 7.156-2.469 13.73-6.594 18.937-.195.336-.57.531-.957.492a.9946.9946 0 0 1-.851-.66c-.129-.367-.035-.777.246-1.051 3.855-4.867 6.156-11.023 6.156-17.718 0-6.696-2.301-12.852-6.156-17.719-.262-.317-.301-.762-.102-1.121.204-.36.602-.559 1.008-.504z" />
          <path d="M13.74 7.563c.231.039.442.164.594.343 3.508 4.059 5.625 9.371 5.625 15.157 0 5.785-2.113 11.097-5.625 15.156-.363.422-1 .472-1.422.109-.422-.363-.472-1-.109-1.422 3.211-3.711 5.156-8.551 5.156-13.843 0-5.293-1.949-10.133-5.156-13.844-.27-.309-.324-.75-.141-1.114.188-.367.578-.582.985-.542h.093z" />
          <path d="M7.584 11.438c.227.031.438.144.594.312 2.953 2.863 4.781 6.875 4.781 11.313 0 4.433-1.828 8.449-4.781 11.312-.398.387-1.035.383-1.422-.016-.387-.398-.383-1.035.016-1.421 2.582-2.504 4.187-5.993 4.187-9.875 0-3.883-1.605-7.372-4.187-9.875-.321-.282-.426-.739-.266-1.133.164-.395.559-.641.984-.617h.094zM1.178 15.531c.121.02.238.063.344.125 2.633 1.414 4.437 4.215 4.437 7.407 0 3.195-1.797 5.996-4.437 7.406-.492.258-1.102.07-1.36-.422-.257-.492-.07-1.102.422-1.359 2.012-1.075 3.375-3.176 3.375-5.625 0-2.446-1.371-4.551-3.375-5.625-.441-.204-.676-.692-.551-1.165.122-.468.567-.785 1.051-.742h.094z" />
      </svg>

      <div class="card-number" v-if="!last4">
        <section>{{ numberAndDefault.slice(0, 4) }}</section>
        <section>{{ numberAndDefault.slice(4, 8) }}</section>
        <section>{{ numberAndDefault.slice(8, 12) }}</section>
        <section>{{ numberAndDefault.slice(12, (numberAndDefault.length)) }}</section>
      </div>

      <div class="card-number" v-else>
        <section>****</section>
        <section>****</section>
        <section>****</section>
        <section>{{ last4 }}</section>
      </div>


      <div class="expiration">
        <span class="expiration-text">Exp. Date:</span>
        <span class="expiration-date">{{ expiration ? expiration : '06/24' }}</span>
      </div>

      <div class="card-holder">
        {{ cardholderAndDefault }}
      </div>

      <div class="card-type">
        <BitCardTypeIcon v-if="!type" :icon="creditCardType"/>
        <BitCardTypeIcon v-else :icon="type" />
      </div>

    </div>

</div>

</template>

<script>
import BitCardTypeIcon from '@/components/portal/cardtypeicon.vue';

export default {
  name: 'BACreditCard',
  components: {
    BitCardTypeIcon
  },
  props: {
    cardholder: {
      required: false
    },
    number: {
      required: false
    },
    expiration: {
      required: false
    },
    last4: {
      required: false
    },
    type: {
      required: false
    }
  },
  computed: {
    // We have to compute our defaults because the default included in the props objects only accounts for undefined, not null or an empty string
    cardholderAndDefault() {
      return this.cardholder || 'Max Mustermann'
    },
    numberAndDefault() {
      return this.number || '0118999881999119'
    },
    creditCardType() {
      if(this.number == null || this.number == undefined || this.number.slice(0,1) == 4) {
        return 'visa'
      } else if(this.number.slice(0,2) == 34 || this.number.slice(0,2) == 37) {
        return 'amex'
      } else if(this.number.slice(0,2) > 50 && this.number.slice(0,2) < 56 ||
                this.number.slice(0,6) > 222099 && this.number.slice(0,6) < 272100) {
        return 'mastercard'
      } else if(this.number.slice(0,4) == 6011 ||
                this.number.slice(0,4) > 643 && this.number.slice(0,4) < 649 ||
                this.number.slice(0,4) == 65 ||
                this.number.slice(0,6) > 622125 && this.number.slice(0,6) < 622925) {
        return 'discover'
      } else {
        return 'visa' // default for front-page
      }
    }
  },
  methods: {
  }
}
</script>

<style scoped lang="less">
@import "../../assets/less/theme.less";

.card {
  width: 325px;
  height: 200px;

  .front {
    position: absolute;
    width: inherit;
    height: inherit;
    border-radius: 15px;
    color: #fff;
    text-shadow: 0 1px 1px rgba(0, 0, 0, 0.3);
    box-shadow: 0 1px 10px 1px rgba(0,0,0,0.3);
    backface-visibility: hidden;
    background-image: linear-gradient(to right, @ba-purple, lighten(@ba-purple, 10%));
    overflow: hidden;
  }

  .chip {
    position: relative;
    top: 60px;
    left: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 32px;
    border-radius: 5px;
    background-image: linear-gradient(to bottom left, #ffecc7, #d0b978);
    overflow: hidden;

    .chip-line {
      position: absolute;
      width: 100%;
      height: 1px;
      background-color: #333;

      &:nth-child(1) {
        top: 10px;
      }

      &:nth-child(2) {
        top: 16px;
      }

      &:nth-child(3) {
        top: 22px;
      }

      &:nth-child(4) {
        left: 20px;
        width: 1px;
        height: 40px;
      }
    }

    .chip-main {
      width: 16px;
      height: 20px;
      border: 1px solid #333;
      border-radius: 3px;
      background-image: linear-gradient(to bottom left, #efdbab, #e1cb94);
      z-index: 1;
    }
  }

  .wave {
    position: relative;
    top: 29px;
    left: 80px;
  }

  .card-number {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 40px 25px 10px;
    font-size: 20px;
    letter-spacing: .25rem;
  }

  .expiration {
    margin-top: -10px;
    margin-left: 25px;
    text-transform: uppercase;

    .expiration-text {
      font-size: 9px;
      color: rgba(255, 255, 255, 0.8);
    }
    .expiration-date {
      font-size: 14px;
      color: rgba(255,255,255, 1);
      margin-left: 5px;
      letter-spacing: .1rem;
    }
  }

  .card-holder {
    margin: 0px 25px 8px 25px;
    text-transform: uppercase;
    font-size: 16px;
  }

  .card-type {
    position: absolute;
    width: 60px;
    right: 15px;
    bottom: 12px;
  }
}
</style>
